import { Button, SaveButton, Toolbar } from "react-admin";

export const Accordion = ({ open, children }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxHeight: open ? "100rem" : "0",
        overflow: "hidden",
        transition: "max-height 0.5s ease-in-out",
        gap: ".5rem",
      }}
    >
      {children}
    </div>
  );
};

export const CustomToolbar = ({ close }) => (
  <Toolbar>
    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
      <SaveButton alwaysEnable />
      <Button
        onClick={close}
        label="Затвори"
      />
    </div>
  </Toolbar>
);
